<form [formGroup]="unitOfMeasureFormGroup"
      (submit)="onSubmit()">
  <div class="modal-backdrop fade"
       [class.show]="show"></div>
  <div class="modal d-block fade"
       [class.show]="show"
       tabindex="-1"
       role="dialog"
       aria-labelledby="modalIdLabel">
    <div role="document"
         class="modal-dialog modal-dialog-centered"
         style="max-width: 30%">
      <div class="modal-content"
           style="min-height: 60vh">
        <div class="modal-header">
          <h5 class="modal-title text-primary-dark">{{unitOfMeasure?unitOfMeasure.singular:'New Unit of Measure'}}</h5>
          <button type="button"
                  class="close"
                  (click)="close()"
                  aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label for="name">Name</label>
            <input type="text"
                   class="form-control"
                   formControlName="singular"
                   id="name" />
          </div>
          <div class="form-group">
            <label for="description">Plural Name</label>
            <input type="text"
                   class="form-control"
                   formControlName="plural"
                   id="pname" />
          </div>
        </div>
        <div class="modal-footer">
          <button type="button"
                  class="btn btn-secondary"
                  (click)="close()">
            Close
          </button>
          <button type="submit"
                  appSpinner
                  [isLoading]="isLoading"
                  [disabled]="!unitOfMeasureFormGroup.valid||isLoading"
                  class="btn btn-primary">
            Save Unit
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
